import { Component, Input, OnInit } from '@angular/core';
import { Assessment } from '../../models/models.lib';
import { LoggerService } from '../../shared/logger.service';
import _ from 'lodash';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormArray,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule
} from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DialogModule, KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';

@Component({
  selector: 'casi-assessment-introduction',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: true,
  templateUrl: './assessment-introduction.component.html',
  styleUrl: './assessment-introduction.component.scss'
})
export class AssessmentIntroductionComponent implements OnInit {
  private _assessment: Assessment | undefined;

  @Input({ required: true }) set assessment(val: Assessment) {
    this.logger.debug(`assessment: `, val);
    this._assessment = val;
  }
  get assessment(): Assessment | undefined {
    return this._assessment;
  };

  @Input({ required: true }) assessmentForm!: FormGroup;


  constructor(
    private logger: LoggerService,
    private fb: FormBuilder
  ) { }

  // //#region Form
  get scaleArray(): FormArray {
    return (this.assessmentForm.get('rating_scale') as FormArray)
      ?? this.fb.array([]);
  }
  // //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');

  }


}
